import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Collection, ForEachModel } from '@morningtrain/react-resources'
import { Translator } from '@morningtrain/react-translations'
import ShiftExchangeEntryForApproval from '../ShiftExchangeEntryForApproval'
import { StaticFilter } from '@morningtrain/react-filters'

export default function ManageShiftExchangeSmartview ({ id }) {
  return (
    <Translator namespace='shiftexchange'>
      <Smartview size='4xl'>
        <Collection resourceName='shifts.exchange' operationName='manageable' operationContext={{ context: 'smartview-single', id: id }}>
          <StaticFilter name='id' value={id} />
          <ForEachModel>
            <ShiftExchangeEntryForApproval />
          </ForEachModel>
        </Collection>
      </Smartview>
    </Translator>
  )
}
